import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Home from './pages/Home';
import Main from './pages/Main';
import Events from './pages/EventsPage';
import AboutUs from './pages/AboutUs';
import './App.css';

const sections = [
  { id: 'home', component: Home, label: 'Home', fullBleed: true },
  { id: 'events', component: Events, label: 'Events' },
  { id: 'about-us', component: AboutUs, label: 'About Us' },
];

function App() {
  return (
    <Box sx={{ bgcolor: 'background.default' }}>
      <Routes>
        <Route path="*" element={<Main sections={sections} />} />
      </Routes>
    </Box>
  );
}

export default App;
